const params = new URLSearchParams(window.location.search);
const utmSource = params.get('utm_source');
const utmMedium = params.get('utm_medium');
const utmCampaign = params.get('utm_campaign');

if (utmSource != null) {
  setCookie('utm_source', utmSource);
}

if (utmMedium != null) {
  setCookie('utm_medium', utmMedium);
}

if (utmCampaign != null) {
  setCookie('utm_campaign', utmCampaign);
}

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  let requestedCookie = '';

  cookies.forEach((cookie) => {
    const cookieArr = cookie.split('=');

    if (name == cookieArr[0]) {
      requestedCookie = cookieArr[1];
    }
  });

  return requestedCookie;
}

function setCookie(name, value, exdays = 1) {
  const d = new Date();

  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie =
    name + '=' + value + ';' + expires + `;path=/;domain=narrative4.com`;
}
